module.exports = __webpack_public_path__ + "media/have-room-have-condom.2ec59ff4.mp3";